import React from "react";
import SaltComply from "../images/SaltStack_Comply_white.png";

const Tabs = (props) => {
  const [openTab, setOpenTab] = React.useState(1);
  return (
    <div className="bg-gray-100">
      <div className="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div className="lg:col-span-1 flex flex-col justify-center">
            <h3 className="text-3xl leading-9 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              {props.data.title}
            </h3>

            <ul
              className="flex flex-col mb-0 list-none flex-wrap pt-3 pb-4 "
              role="tablist"
            >
              {props.data.items.map((li, i) => (
                <li className="-mb-px lg:mr-2 last:mr-0 flex-auto text-center my-4 animate-link-child-hover">
                  <a
                    className={
                      "transition duraction-300 text-sm font-bold px-5 py-3 shadow-lg rounded flex items-center leading-normal text-left border-l-4 border-indigo-900 justify-between " +
                      (openTab === li.id
                        ? "text-white bg-indigo-600"
                        : "text-gray-900" + " bg-white hover:text-indigo-900")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenTab(li.id);
                    }}
                    data-toggle="tab"
                    href={`#link` + li.id}
                    role="tablist"
                  >
                    {li.title}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.634"
                      height="30.705"
                      viewBox="0 0 18.634 30.705"
                      fill="currentColor"
                      className="inline-block transform transition-all duration-300 ease-in-out h-3 ml-2"
                    >
                      <path
                        id="icon_chevron"
                        d="M20.073,19.193,6.408,32.858a1.687,1.687,0,0,1-2.386,0L2.427,31.264a1.687,1.687,0,0,1,0-2.384L13.254,18,2.425,7.119a1.687,1.687,0,0,1,0-2.384L4.021,3.142a1.687,1.687,0,0,1,2.386,0L20.072,16.807A1.688,1.688,0,0,1,20.073,19.193Z"
                        transform="translate(-1.933 -2.648)"
                      />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className=" sm:grid sm:grid-cols-1 sm:gap-x-8 sm:gap-y-10 lg:col-span-2 lg:mt-10 ">
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-4 shadow-lg rounded">
              <div className="px-4 py-5 flex-auto">
                <div className="tab-content tab-space text-center">
                  {props.data.items.map((li, i) => (
                    <div
                      className={openTab === li.id ? "block" : "hidden"}
                      id={`#link` + li.id}
                    >
                      <img
                        className="mx-auto w-3/4 rounded p-4"
                        src={li.image}
                      ></img>
                      <p>{li.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
